/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as publicRouteRouteImport } from './routes/(public)/route'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppProfileRouteImport } from './routes/app/profile'
import { Route as AppNotificationsRouteImport } from './routes/app/notifications'
import { Route as publicTermsRouteImport } from './routes/(public)/terms'
import { Route as publicPrivacyRouteImport } from './routes/(public)/privacy'
import { Route as publicPricingRouteImport } from './routes/(public)/pricing'
import { Route as publicFeaturesRouteImport } from './routes/(public)/features'
import { Route as publicAboutRouteImport } from './routes/(public)/about'
import { Route as AppOnboardingRouteRouteImport } from './routes/app/onboarding/route'
import { Route as AppGamesRouteRouteImport } from './routes/app/games/route'
import { Route as AppGamesIndexRouteImport } from './routes/app/games/index'
import { Route as AppClubsIndexRouteImport } from './routes/app/clubs/index'
import { Route as AppUsersUserIdRouteImport } from './routes/app/users/$userId'
import { Route as AppOnboardingStep3RouteImport } from './routes/app/onboarding/step-3'
import { Route as AppOnboardingStep2RouteImport } from './routes/app/onboarding/step-2'
import { Route as AppOnboardingStep1RouteImport } from './routes/app/onboarding/step-1'
import { Route as AppClubsSlugRouteRouteImport } from './routes/app/clubs/$slug/route'
import { Route as AppGamesGameIndexRouteImport } from './routes/app/games/$game/index'
import { Route as AppClubsSlugIndexRouteImport } from './routes/app/clubs/$slug/index'
import { Route as AppClubsJoinCodeRouteImport } from './routes/app/clubs/join/$code'
import { Route as AppClubsSlugSettingsRouteImport } from './routes/app/clubs/$slug/settings'
import { Route as AppClubsSlugQueuesIndexRouteImport } from './routes/app/clubs/$slug/queues/index'
import { Route as AppClubsSlugQueuesQueueIdIndexRouteImport } from './routes/app/clubs/$slug/queues/$queueId/index'
import { Route as AppClubsSlugQueuesQueueIdSettingsRouteImport } from './routes/app/clubs/$slug/queues/$queueId/settings'
import { Route as AppClubsSlugQueuesQueueIdFlowEditorRouteImport } from './routes/app/clubs/$slug/queues/$queueId/flow-editor'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const publicRouteRoute = publicRouteRouteImport.update({
  id: '/(public)',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicRouteRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const publicTermsRoute = publicTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPrivacyRoute = publicPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicPricingRoute = publicPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicFeaturesRoute = publicFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => publicRouteRoute,
} as any)
const publicAboutRoute = publicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => publicRouteRoute,
} as any)
const AppOnboardingRouteRoute = AppOnboardingRouteRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGamesRouteRoute = AppGamesRouteRouteImport.update({
  id: '/games',
  path: '/games',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGamesIndexRoute = AppGamesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppGamesRouteRoute,
} as any)
const AppClubsIndexRoute = AppClubsIndexRouteImport.update({
  id: '/clubs/',
  path: '/clubs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUsersUserIdRoute = AppUsersUserIdRouteImport.update({
  id: '/users/$userId',
  path: '/users/$userId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOnboardingStep3Route = AppOnboardingStep3RouteImport.update({
  id: '/step-3',
  path: '/step-3',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppOnboardingStep2Route = AppOnboardingStep2RouteImport.update({
  id: '/step-2',
  path: '/step-2',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppOnboardingStep1Route = AppOnboardingStep1RouteImport.update({
  id: '/step-1',
  path: '/step-1',
  getParentRoute: () => AppOnboardingRouteRoute,
} as any)
const AppClubsSlugRouteRoute = AppClubsSlugRouteRouteImport.update({
  id: '/clubs/$slug',
  path: '/clubs/$slug',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppGamesGameIndexRoute = AppGamesGameIndexRouteImport.update({
  id: '/$game/',
  path: '/$game/',
  getParentRoute: () => AppGamesRouteRoute,
} as any)
const AppClubsSlugIndexRoute = AppClubsSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsJoinCodeRoute = AppClubsJoinCodeRouteImport.update({
  id: '/clubs/join/$code',
  path: '/clubs/join/$code',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClubsSlugSettingsRoute = AppClubsSlugSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsSlugQueuesIndexRoute = AppClubsSlugQueuesIndexRouteImport.update({
  id: '/queues/',
  path: '/queues/',
  getParentRoute: () => AppClubsSlugRouteRoute,
} as any)
const AppClubsSlugQueuesQueueIdIndexRoute =
  AppClubsSlugQueuesQueueIdIndexRouteImport.update({
    id: '/queues/$queueId/',
    path: '/queues/$queueId/',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)
const AppClubsSlugQueuesQueueIdSettingsRoute =
  AppClubsSlugQueuesQueueIdSettingsRouteImport.update({
    id: '/queues/$queueId/settings',
    path: '/queues/$queueId/settings',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)
const AppClubsSlugQueuesQueueIdFlowEditorRoute =
  AppClubsSlugQueuesQueueIdFlowEditorRouteImport.update({
    id: '/queues/$queueId/flow-editor',
    path: '/queues/$queueId/flow-editor',
    getParentRoute: () => AppClubsSlugRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/app': typeof AppRouteRouteWithChildren
  '/app/games': typeof AppGamesRouteRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRouteRouteWithChildren
  '/about': typeof publicAboutRoute
  '/features': typeof publicFeaturesRoute
  '/pricing': typeof publicPricingRoute
  '/privacy': typeof publicPrivacyRoute
  '/terms': typeof publicTermsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/profile': typeof AppProfileRoute
  '/app/settings': typeof AppSettingsRoute
  '/': typeof publicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/clubs/$slug': typeof AppClubsSlugRouteRouteWithChildren
  '/app/onboarding/step-1': typeof AppOnboardingStep1Route
  '/app/onboarding/step-2': typeof AppOnboardingStep2Route
  '/app/onboarding/step-3': typeof AppOnboardingStep3Route
  '/app/users/$userId': typeof AppUsersUserIdRoute
  '/app/clubs/': typeof AppClubsIndexRoute
  '/app/games/': typeof AppGamesIndexRoute
  '/app/clubs/$slug/settings': typeof AppClubsSlugSettingsRoute
  '/app/clubs/join/$code': typeof AppClubsJoinCodeRoute
  '/app/clubs/$slug/': typeof AppClubsSlugIndexRoute
  '/app/games/$game/': typeof AppGamesGameIndexRoute
  '/app/clubs/$slug/queues/': typeof AppClubsSlugQueuesIndexRoute
  '/app/clubs/$slug/queues/$queueId/flow-editor': typeof AppClubsSlugQueuesQueueIdFlowEditorRoute
  '/app/clubs/$slug/queues/$queueId/settings': typeof AppClubsSlugQueuesQueueIdSettingsRoute
  '/app/clubs/$slug/queues/$queueId/': typeof AppClubsSlugQueuesQueueIdIndexRoute
}
export interface FileRoutesByTo {
  '/app/onboarding': typeof AppOnboardingRouteRouteWithChildren
  '/about': typeof publicAboutRoute
  '/features': typeof publicFeaturesRoute
  '/pricing': typeof publicPricingRoute
  '/privacy': typeof publicPrivacyRoute
  '/terms': typeof publicTermsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/profile': typeof AppProfileRoute
  '/app/settings': typeof AppSettingsRoute
  '/': typeof publicIndexRoute
  '/app': typeof AppIndexRoute
  '/app/onboarding/step-1': typeof AppOnboardingStep1Route
  '/app/onboarding/step-2': typeof AppOnboardingStep2Route
  '/app/onboarding/step-3': typeof AppOnboardingStep3Route
  '/app/users/$userId': typeof AppUsersUserIdRoute
  '/app/clubs': typeof AppClubsIndexRoute
  '/app/games': typeof AppGamesIndexRoute
  '/app/clubs/$slug/settings': typeof AppClubsSlugSettingsRoute
  '/app/clubs/join/$code': typeof AppClubsJoinCodeRoute
  '/app/clubs/$slug': typeof AppClubsSlugIndexRoute
  '/app/games/$game': typeof AppGamesGameIndexRoute
  '/app/clubs/$slug/queues': typeof AppClubsSlugQueuesIndexRoute
  '/app/clubs/$slug/queues/$queueId/flow-editor': typeof AppClubsSlugQueuesQueueIdFlowEditorRoute
  '/app/clubs/$slug/queues/$queueId/settings': typeof AppClubsSlugQueuesQueueIdSettingsRoute
  '/app/clubs/$slug/queues/$queueId': typeof AppClubsSlugQueuesQueueIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(public)': typeof publicRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/app/games': typeof AppGamesRouteRouteWithChildren
  '/app/onboarding': typeof AppOnboardingRouteRouteWithChildren
  '/(public)/about': typeof publicAboutRoute
  '/(public)/features': typeof publicFeaturesRoute
  '/(public)/pricing': typeof publicPricingRoute
  '/(public)/privacy': typeof publicPrivacyRoute
  '/(public)/terms': typeof publicTermsRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/profile': typeof AppProfileRoute
  '/app/settings': typeof AppSettingsRoute
  '/(public)/': typeof publicIndexRoute
  '/app/': typeof AppIndexRoute
  '/app/clubs/$slug': typeof AppClubsSlugRouteRouteWithChildren
  '/app/onboarding/step-1': typeof AppOnboardingStep1Route
  '/app/onboarding/step-2': typeof AppOnboardingStep2Route
  '/app/onboarding/step-3': typeof AppOnboardingStep3Route
  '/app/users/$userId': typeof AppUsersUserIdRoute
  '/app/clubs/': typeof AppClubsIndexRoute
  '/app/games/': typeof AppGamesIndexRoute
  '/app/clubs/$slug/settings': typeof AppClubsSlugSettingsRoute
  '/app/clubs/join/$code': typeof AppClubsJoinCodeRoute
  '/app/clubs/$slug/': typeof AppClubsSlugIndexRoute
  '/app/games/$game/': typeof AppGamesGameIndexRoute
  '/app/clubs/$slug/queues/': typeof AppClubsSlugQueuesIndexRoute
  '/app/clubs/$slug/queues/$queueId/flow-editor': typeof AppClubsSlugQueuesQueueIdFlowEditorRoute
  '/app/clubs/$slug/queues/$queueId/settings': typeof AppClubsSlugQueuesQueueIdSettingsRoute
  '/app/clubs/$slug/queues/$queueId/': typeof AppClubsSlugQueuesQueueIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/app'
    | '/app/games'
    | '/app/onboarding'
    | '/about'
    | '/features'
    | '/pricing'
    | '/privacy'
    | '/terms'
    | '/app/notifications'
    | '/app/profile'
    | '/app/settings'
    | '/'
    | '/app/'
    | '/app/clubs/$slug'
    | '/app/onboarding/step-1'
    | '/app/onboarding/step-2'
    | '/app/onboarding/step-3'
    | '/app/users/$userId'
    | '/app/clubs/'
    | '/app/games/'
    | '/app/clubs/$slug/settings'
    | '/app/clubs/join/$code'
    | '/app/clubs/$slug/'
    | '/app/games/$game/'
    | '/app/clubs/$slug/queues/'
    | '/app/clubs/$slug/queues/$queueId/flow-editor'
    | '/app/clubs/$slug/queues/$queueId/settings'
    | '/app/clubs/$slug/queues/$queueId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/app/onboarding'
    | '/about'
    | '/features'
    | '/pricing'
    | '/privacy'
    | '/terms'
    | '/app/notifications'
    | '/app/profile'
    | '/app/settings'
    | '/'
    | '/app'
    | '/app/onboarding/step-1'
    | '/app/onboarding/step-2'
    | '/app/onboarding/step-3'
    | '/app/users/$userId'
    | '/app/clubs'
    | '/app/games'
    | '/app/clubs/$slug/settings'
    | '/app/clubs/join/$code'
    | '/app/clubs/$slug'
    | '/app/games/$game'
    | '/app/clubs/$slug/queues'
    | '/app/clubs/$slug/queues/$queueId/flow-editor'
    | '/app/clubs/$slug/queues/$queueId/settings'
    | '/app/clubs/$slug/queues/$queueId'
  id:
    | '__root__'
    | '/(public)'
    | '/app'
    | '/app/games'
    | '/app/onboarding'
    | '/(public)/about'
    | '/(public)/features'
    | '/(public)/pricing'
    | '/(public)/privacy'
    | '/(public)/terms'
    | '/app/notifications'
    | '/app/profile'
    | '/app/settings'
    | '/(public)/'
    | '/app/'
    | '/app/clubs/$slug'
    | '/app/onboarding/step-1'
    | '/app/onboarding/step-2'
    | '/app/onboarding/step-3'
    | '/app/users/$userId'
    | '/app/clubs/'
    | '/app/games/'
    | '/app/clubs/$slug/settings'
    | '/app/clubs/join/$code'
    | '/app/clubs/$slug/'
    | '/app/games/$game/'
    | '/app/clubs/$slug/queues/'
    | '/app/clubs/$slug/queues/$queueId/flow-editor'
    | '/app/clubs/$slug/queues/$queueId/settings'
    | '/app/clubs/$slug/queues/$queueId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  publicRouteRoute: typeof publicRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)': {
      id: '/(public)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/(public)/terms': {
      id: '/(public)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof publicTermsRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/privacy': {
      id: '/(public)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof publicPrivacyRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/pricing': {
      id: '/(public)/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof publicPricingRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/features': {
      id: '/(public)/features'
      path: '/features'
      fullPath: '/features'
      preLoaderRoute: typeof publicFeaturesRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/(public)/about': {
      id: '/(public)/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof publicAboutRouteImport
      parentRoute: typeof publicRouteRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/games': {
      id: '/app/games'
      path: '/games'
      fullPath: '/app/games'
      preLoaderRoute: typeof AppGamesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/games/': {
      id: '/app/games/'
      path: '/'
      fullPath: '/app/games/'
      preLoaderRoute: typeof AppGamesIndexRouteImport
      parentRoute: typeof AppGamesRouteRoute
    }
    '/app/clubs/': {
      id: '/app/clubs/'
      path: '/clubs'
      fullPath: '/app/clubs/'
      preLoaderRoute: typeof AppClubsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/users/$userId': {
      id: '/app/users/$userId'
      path: '/users/$userId'
      fullPath: '/app/users/$userId'
      preLoaderRoute: typeof AppUsersUserIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/onboarding/step-3': {
      id: '/app/onboarding/step-3'
      path: '/step-3'
      fullPath: '/app/onboarding/step-3'
      preLoaderRoute: typeof AppOnboardingStep3RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/onboarding/step-2': {
      id: '/app/onboarding/step-2'
      path: '/step-2'
      fullPath: '/app/onboarding/step-2'
      preLoaderRoute: typeof AppOnboardingStep2RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/onboarding/step-1': {
      id: '/app/onboarding/step-1'
      path: '/step-1'
      fullPath: '/app/onboarding/step-1'
      preLoaderRoute: typeof AppOnboardingStep1RouteImport
      parentRoute: typeof AppOnboardingRouteRoute
    }
    '/app/clubs/$slug': {
      id: '/app/clubs/$slug'
      path: '/clubs/$slug'
      fullPath: '/app/clubs/$slug'
      preLoaderRoute: typeof AppClubsSlugRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/games/$game/': {
      id: '/app/games/$game/'
      path: '/$game'
      fullPath: '/app/games/$game/'
      preLoaderRoute: typeof AppGamesGameIndexRouteImport
      parentRoute: typeof AppGamesRouteRoute
    }
    '/app/clubs/$slug/': {
      id: '/app/clubs/$slug/'
      path: '/'
      fullPath: '/app/clubs/$slug/'
      preLoaderRoute: typeof AppClubsSlugIndexRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/join/$code': {
      id: '/app/clubs/join/$code'
      path: '/clubs/join/$code'
      fullPath: '/app/clubs/join/$code'
      preLoaderRoute: typeof AppClubsJoinCodeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/clubs/$slug/settings': {
      id: '/app/clubs/$slug/settings'
      path: '/settings'
      fullPath: '/app/clubs/$slug/settings'
      preLoaderRoute: typeof AppClubsSlugSettingsRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queues/': {
      id: '/app/clubs/$slug/queues/'
      path: '/queues'
      fullPath: '/app/clubs/$slug/queues/'
      preLoaderRoute: typeof AppClubsSlugQueuesIndexRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queues/$queueId/': {
      id: '/app/clubs/$slug/queues/$queueId/'
      path: '/queues/$queueId'
      fullPath: '/app/clubs/$slug/queues/$queueId/'
      preLoaderRoute: typeof AppClubsSlugQueuesQueueIdIndexRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queues/$queueId/settings': {
      id: '/app/clubs/$slug/queues/$queueId/settings'
      path: '/queues/$queueId/settings'
      fullPath: '/app/clubs/$slug/queues/$queueId/settings'
      preLoaderRoute: typeof AppClubsSlugQueuesQueueIdSettingsRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
    '/app/clubs/$slug/queues/$queueId/flow-editor': {
      id: '/app/clubs/$slug/queues/$queueId/flow-editor'
      path: '/queues/$queueId/flow-editor'
      fullPath: '/app/clubs/$slug/queues/$queueId/flow-editor'
      preLoaderRoute: typeof AppClubsSlugQueuesQueueIdFlowEditorRouteImport
      parentRoute: typeof AppClubsSlugRouteRoute
    }
  }
}

interface publicRouteRouteChildren {
  publicAboutRoute: typeof publicAboutRoute
  publicFeaturesRoute: typeof publicFeaturesRoute
  publicPricingRoute: typeof publicPricingRoute
  publicPrivacyRoute: typeof publicPrivacyRoute
  publicTermsRoute: typeof publicTermsRoute
  publicIndexRoute: typeof publicIndexRoute
}

const publicRouteRouteChildren: publicRouteRouteChildren = {
  publicAboutRoute: publicAboutRoute,
  publicFeaturesRoute: publicFeaturesRoute,
  publicPricingRoute: publicPricingRoute,
  publicPrivacyRoute: publicPrivacyRoute,
  publicTermsRoute: publicTermsRoute,
  publicIndexRoute: publicIndexRoute,
}

const publicRouteRouteWithChildren = publicRouteRoute._addFileChildren(
  publicRouteRouteChildren,
)

interface AppGamesRouteRouteChildren {
  AppGamesIndexRoute: typeof AppGamesIndexRoute
  AppGamesGameIndexRoute: typeof AppGamesGameIndexRoute
}

const AppGamesRouteRouteChildren: AppGamesRouteRouteChildren = {
  AppGamesIndexRoute: AppGamesIndexRoute,
  AppGamesGameIndexRoute: AppGamesGameIndexRoute,
}

const AppGamesRouteRouteWithChildren = AppGamesRouteRoute._addFileChildren(
  AppGamesRouteRouteChildren,
)

interface AppOnboardingRouteRouteChildren {
  AppOnboardingStep1Route: typeof AppOnboardingStep1Route
  AppOnboardingStep2Route: typeof AppOnboardingStep2Route
  AppOnboardingStep3Route: typeof AppOnboardingStep3Route
}

const AppOnboardingRouteRouteChildren: AppOnboardingRouteRouteChildren = {
  AppOnboardingStep1Route: AppOnboardingStep1Route,
  AppOnboardingStep2Route: AppOnboardingStep2Route,
  AppOnboardingStep3Route: AppOnboardingStep3Route,
}

const AppOnboardingRouteRouteWithChildren =
  AppOnboardingRouteRoute._addFileChildren(AppOnboardingRouteRouteChildren)

interface AppClubsSlugRouteRouteChildren {
  AppClubsSlugSettingsRoute: typeof AppClubsSlugSettingsRoute
  AppClubsSlugIndexRoute: typeof AppClubsSlugIndexRoute
  AppClubsSlugQueuesIndexRoute: typeof AppClubsSlugQueuesIndexRoute
  AppClubsSlugQueuesQueueIdFlowEditorRoute: typeof AppClubsSlugQueuesQueueIdFlowEditorRoute
  AppClubsSlugQueuesQueueIdSettingsRoute: typeof AppClubsSlugQueuesQueueIdSettingsRoute
  AppClubsSlugQueuesQueueIdIndexRoute: typeof AppClubsSlugQueuesQueueIdIndexRoute
}

const AppClubsSlugRouteRouteChildren: AppClubsSlugRouteRouteChildren = {
  AppClubsSlugSettingsRoute: AppClubsSlugSettingsRoute,
  AppClubsSlugIndexRoute: AppClubsSlugIndexRoute,
  AppClubsSlugQueuesIndexRoute: AppClubsSlugQueuesIndexRoute,
  AppClubsSlugQueuesQueueIdFlowEditorRoute:
    AppClubsSlugQueuesQueueIdFlowEditorRoute,
  AppClubsSlugQueuesQueueIdSettingsRoute:
    AppClubsSlugQueuesQueueIdSettingsRoute,
  AppClubsSlugQueuesQueueIdIndexRoute: AppClubsSlugQueuesQueueIdIndexRoute,
}

const AppClubsSlugRouteRouteWithChildren =
  AppClubsSlugRouteRoute._addFileChildren(AppClubsSlugRouteRouteChildren)

interface AppRouteRouteChildren {
  AppGamesRouteRoute: typeof AppGamesRouteRouteWithChildren
  AppOnboardingRouteRoute: typeof AppOnboardingRouteRouteWithChildren
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClubsSlugRouteRoute: typeof AppClubsSlugRouteRouteWithChildren
  AppUsersUserIdRoute: typeof AppUsersUserIdRoute
  AppClubsIndexRoute: typeof AppClubsIndexRoute
  AppClubsJoinCodeRoute: typeof AppClubsJoinCodeRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppGamesRouteRoute: AppGamesRouteRouteWithChildren,
  AppOnboardingRouteRoute: AppOnboardingRouteRouteWithChildren,
  AppNotificationsRoute: AppNotificationsRoute,
  AppProfileRoute: AppProfileRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppClubsSlugRouteRoute: AppClubsSlugRouteRouteWithChildren,
  AppUsersUserIdRoute: AppUsersUserIdRoute,
  AppClubsIndexRoute: AppClubsIndexRoute,
  AppClubsJoinCodeRoute: AppClubsJoinCodeRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  publicRouteRoute: publicRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
